import type { Company } from '../types';

import React from 'react';

export type CompanyContextProps = Company & {
  country: string;
};

export const CompanyContext = React.createContext<CompanyContextProps>({
  country: 'UA',
} as any);

export const useCompany = (): CompanyContextProps => {
  return React.useContext(CompanyContext);
};
